import SouthIcon from "@mui/icons-material/South";
import { Stack, Typography } from "@mui/material";
import { PatientWeight } from "src/api/types";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import GraphCard from "./components/GraphCard";
import InformationCard from "./components/InformationCard";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

interface CardProps {
  patientWeight: PatientWeight;
  page: string;
  onNext: () => void;
}

const GoalCard = ({ patientWeight, page, onNext }: CardProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const component = "goalCard";

  const currentLabel = t(`${page}.${component}.currentBmi`);
  const goalLabel = t(`${page}.${component}.goalBmi`);
  const informationText = t(`${page}.${component}.additionalInformation`);

  const goalWeight = useMemo(
    () => patientWeight.weight - (patientWeight.goal || 0),
    [patientWeight.goal, patientWeight.weight]
  );

  return (
    <WhiteCard
      height="max-content"
      sx={{
        borderRadius: "30px",
        background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0.31%, rgba(255, 255, 255, 0.36) 99.69%), rgba(0, 181, 184, 0.25)`,
      }}
      onClick={onNext}
    >
      <Typography variant="h4">{t(`${page}.${component}.header`)}</Typography>
      <Stack alignItems="start" gap={1}>
        <Typography>{t(`${page}.${component}.weightCaption`)}</Typography>
        <Stack direction="row" alignItems="center">
          <SouthIcon sx={{ fontSize: isMobile ? "2rem" : "2.5rem" }} />
          <Typography variant="h3" fontWeight={600}>
            {patientWeight.goal} lbs
          </Typography>
        </Stack>
      </Stack>
      <GraphCard
        currentWeight={patientWeight.weight}
        currentLabel={currentLabel}
        goalLabel={goalLabel}
        goalWeight={goalWeight}
      />
      <Stack gap={1.5}>
        <Typography>{t(`${page}.${component}.question`)}</Typography>
        <Typography variant="h6" fontWeight={600}>
          {t(`${page}.${component}.answer`)}
        </Typography>
        <InformationCard text={informationText} />
      </Stack>
    </WhiteCard>
  );
};

export default GoalCard;
